export interface AdminMenuItem {
  key: string;
  title: string;
  description: string;
  icon: string;
  color: string;
  path: string;
}

/** 管理ダッシュボードに並ぶメニュー項目（既定の並び順）。 */
export const ADMIN_MENU_ITEMS: AdminMenuItem[] = [
  {
    key: 'schedule',
    title: 'スケジュール管理',
    description: 'チーム予定・会議室予約',
    icon: 'ri-calendar-line',
    color: 'bg-red-500',
    path: '/admin/schedule',
  },
  {
    key: 'attendance',
    title: '勤怠管理',
    description: '利用者の出勤状況を確認',
    icon: 'ri-calendar-check-line',
    color: 'bg-blue-500',
    path: '/admin/attendance',
  },
  {
    key: 'work',
    title: '作業管理',
    description: '作業内容と進捗を管理',
    icon: 'ri-task-line',
    color: 'bg-purple-500',
    path: '/admin/work',
  },
  {
    key: 'announcements',
    title: '連絡掲示板',
    description: 'お知らせを管理',
    icon: 'ri-notification-line',
    color: 'bg-green-500',
    path: '/admin/announcements',
  },
  {
    key: 'support',
    title: '支援記録',
    description: '個別支援計画・ケース記録',
    icon: 'ri-file-list-3-line',
    color: 'bg-orange-500',
    path: '/admin/support',
  },
  {
    key: 'consultation',
    title: '相談窓口',
    description: '相談内容を確認',
    icon: 'ri-question-answer-line',
    color: 'bg-orange-500',
    path: '/admin/consultation',
  },
  {
    key: 'manuals',
    title: 'マニュアル管理',
    description: '資料・動画を管理',
    icon: 'ri-book-line',
    color: 'bg-pink-500',
    path: '/admin/manuals',
  },
  {
    key: 'linkShare',
    title: 'リンクシェア',
    description: '社内リンクを共有・管理',
    icon: 'ri-link',
    color: 'bg-indigo-500',
    path: '/admin/link-share',
  },
  {
    key: 'messages',
    title: 'メッセージ',
    description: '管理者間でメッセージ送信',
    icon: 'ri-mail-line',
    color: 'bg-teal-500',
    path: '/admin/messages',
  },
  {
    key: 'meeting',
    title: 'オンライン会議',
    description: 'ビデオ会議を開始・参加（AI議事録付き）',
    icon: 'ri-video-line',
    color: 'bg-emerald-500',
    path: '/meeting',
  },
  {
    key: 'mendan',
    title: '面談記録',
    description: '面談音声をAIで解析・構造化',
    icon: 'ri-mic-line',
    color: 'bg-indigo-500',
    path: '/mendan',
  },
  {
    key: 'projects',
    title: 'プロジェクト・TODO共有',
    description: '管理者間でプロジェクト・タスク管理',
    icon: 'ri-projector-line',
    color: 'bg-emerald-500',
    path: '/admin/projects',
  },
  {
    key: 'reports',
    title: '統計・レポート',
    description: '月次の勤怠統計と作業実績',
    icon: 'ri-bar-chart-box-line',
    color: 'bg-indigo-500',
    path: '/admin/reports',
  },
  {
    key: 'businessCards',
    title: '名刺管理システム',
    description: '顧客情報・名刺管理',
    icon: 'ri-contacts-book-line',
    color: 'bg-teal-500',
    path: '/admin/business-cards',
  },
  {
    key: 'salesReports',
    title: '営業報告',
    description: '商談内容・進捗管理',
    icon: 'ri-file-chart-line',
    color: 'bg-cyan-500',
    path: '/admin/sales-reports',
  },
  {
    key: 'dailyReports',
    title: '職員日報',
    description: '事業所別に職員の日報を確認',
    icon: 'ri-draft-line',
    color: 'bg-teal-600',
    path: '/admin/daily-reports',
  },
  {
    key: 'morningMeetings',
    title: '朝礼ドキュメント',
    description: '職員日報から翌日の朝礼資料を作成',
    icon: 'ri-sun-line',
    color: 'bg-amber-500',
    path: '/admin/morning-meetings',
  },
  {
    key: 'officeCalendar',
    title: '事業所カレンダー設定',
    description: '営業時間・休業日・半日営業日を設定',
    icon: 'ri-calendar-event-line',
    color: 'bg-teal-500',
    path: '/admin/office-calendar',
  },
  {
    key: 'leave',
    title: '休暇設定',
    description: '公休・有給・特別有給を管理',
    icon: 'ri-calendar-2-line',
    color: 'bg-rose-500',
    path: '/admin/leave',
  },
  {
    key: 'itSupport',
    title: 'ITサポート(オンライン)',
    description: 'ITの困りごとを申請',
    icon: 'ri-customer-service-2-line',
    color: 'bg-rose-500',
    path: '/it-support',
  },
  {
    key: 'itSupportAi',
    title: 'ITサポート(AI)',
    description: 'AI一次対応のチャット',
    icon: 'ri-robot-2-line',
    color: 'bg-amber-500',
    path: '/it-support/ai',
  },
  {
    key: 'itSupportManage',
    title: 'ITサポート管理',
    description: '申請の受付一覧（IT担当者専用）',
    icon: 'ri-customer-service-2-fill',
    color: 'bg-teal-600',
    path: '/admin/it-support',
  },
  {
    key: 'bugReport',
    title: '不具合報告',
    description: 'システムの不具合をIT開発者へ報告',
    icon: 'ri-bug-2-line',
    color: 'bg-rose-500',
    path: '/it-support/report?type=bug_report',
  },
  {
    key: 'featureRequest',
    title: '機能追加の要望',
    description: 'グループウェアへの要望をIT開発者へ送信',
    icon: 'ri-lightbulb-line',
    color: 'bg-amber-500',
    path: '/it-support/report?type=feature_request',
  },
];